import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import { UsersView } from '../../../components/dashboard/admin';

export default function Users() {
  return (
    <>
      <Helmet>
        <title>Admin Users | Platform Solutions</title>
      </Helmet>

      <Grid item xl={12}>
        <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
          <UsersView />
        </Grid>
      </Grid>
    </>
  );
}
